/* Albatross x Hemisphere — <hm-compare> before/after drag comparison (mouse, touch, keyboard) */
(() => {
  if (!customElements.get('hm-compare')) {
    class HmCompare extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.input = this.querySelector('.hm-cmp__input');
        if (!this.input) return;
        this._ready = true;
        this.dragging = false;
        this._set(parseFloat(this.input.value) || 50);

        this.input.addEventListener('input', () => this._set(parseFloat(this.input.value)));

        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.dragging = true;
          this.classList.add('is-dragging');
          try { this.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
          this._fromPointer(e);
          this.input.focus({ preventScroll: true });
          if (e.pointerType === 'mouse') e.preventDefault();
        });
        this.addEventListener('pointermove', (e) => { if (this.dragging) this._fromPointer(e); });
        const stop = (e) => {
          if (!this.dragging) return;
          this.dragging = false;
          this.classList.remove('is-dragging');
          try { this.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
        };
        this.addEventListener('pointerup', stop);
        this.addEventListener('pointercancel', stop);
        this.addEventListener('lostpointercapture', () => { this.dragging = false; this.classList.remove('is-dragging'); });
        this.addEventListener('dragstart', (e) => e.preventDefault());
      }

      _fromPointer(e) {
        const r = this.getBoundingClientRect();
        if (!r.width) return;
        const pct = ((e.clientX - r.left) / r.width) * 100;
        this._set(pct);
        this.input.value = Math.round(this.pos);
      }

      _set(v) {
        if (isNaN(v)) v = 50;
        this.pos = Math.max(0, Math.min(100, v));
        this.style.setProperty('--pos', this.pos + '%');
        this.input.setAttribute('aria-valuetext', Math.round(this.pos) + '%');
      }
    }
    customElements.define('hm-compare', HmCompare);
  }
})();
